import React, { useEffect, useState } from 'react';
import './App.css';
import Main from "./Router/route";
function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}
export default App;
